import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Link, Typography } from '@mui/material'
import React from 'react'

const PrivacyPolicyLink = ({ sx = {} }) => {
  const PRIVACY_POLICY_URL = '/privacy-policy.html'

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Link
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="hover"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        Privacy Policy
        <OpenInNewIcon sx={{ fontSize: 16 }} />
      </Link>
    </Typography>
  )
}

export default PrivacyPolicyLink
